import React from "react";

//Custom Portal Components
import ContactsSection from "../components/CampaingPageComponents/ContactsSection";

//Styles
// .campaigns-container expande la tabla en desktop (igual que cuando Contactos
// vivía dentro de Campañas).
import "./StyledPages/sendCampaignsPage.css";

/**
 * Página de Contactos (opción propia del menú superior).
 * Muestra la lista de contactos de WhatsApp con búsqueda, filtros, alta,
 * modificación, eliminación e importación.
 */
export default function ContactsPage() {
    return (
        <div className="campaigns-container">
            {/* active=true: la sección carga los contactos al montarse */}
            <ContactsSection active={true} />
        </div>
    );
}
